module.exports = __webpack_public_path__ + "static/img/guanbihuiyi2.f5f9a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/guanbihuiyi2.png
// module id = doQd
// module chunks = 24